
import { Category as SupabaseCategory } from "@/lib/category-service";
import CategoryCard from "@/polymet/components/category-card";

interface CategoryListProps {
  categories: SupabaseCategory[];
  title?: string;
  description?: string;
  className?: string;
  subcategories?: any[];
  productCategories?: any[];
}

export default function CategoryList({
  categories,
  title = "Browse Categories",
  description,
  className = "",
  subcategories = [],
  productCategories = [],
}: CategoryListProps) {
  // Map categories to the format expected by CategoryCard
  const categoriesWithCounts = categories.map((category) => {
    // Find subcategories for this category
    const categorySubcategories = subcategories.filter(
      (sub) => sub.category_id === category.id
    );
    
    // Count total products in this category
    let productCount = 0;
    
    // For each subcategory, find its product categories and count products
    categorySubcategories.forEach((subcategory) => {
      const subProductCategories = productCategories.filter(
        (pc) => pc.subcategory_id === subcategory.id
      );
      
      // Sum up product_count from all product categories
      subProductCategories.forEach((pc) => {
        productCount += pc.product_count || 0;
      });
    });

    return {
      ...category,
      productCount,
      subCategoryCount: categorySubcategories.length,
    };
  });

  return (
    <div className={`w-full ${className}`}>
      {title && (
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold">{title}</h2>
          {description && <p className="text-muted-foreground mt-2">{description}</p>}
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
        {categoriesWithCounts.map((category, index) => (
          <CategoryCard
            key={category.id}
            id={category.id}
            slug={category.slug} // Add slug property
            name={category.name}
            description={category.description || ''}
            image={category.image_url || `/placeholder-category-${(index % 4) + 1}.jpg`}
            subCategoryCount={category.subCategoryCount || 0}
            productCount={category.productCount || 0}
            featured={index === 0} // Mark first as featured
          />
        ))}
      </div>

      {categories.length === 0 && (
        <div className="text-center py-12 bg-gray-50 rounded-md">
          <p className="text-lg text-muted-foreground">No categories found</p>
        </div>
      )}
    </div>
  );
}
